import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  users: null,
  searching: {},
  userByCommunity: {}
}

const getters = {
  userByCommunity: state => state.userByCommunity
}

const mutations = {
  setUsersFromCommunity: (state, { idCommunity, users }) => {
    Vue.set(state.userByCommunity, idCommunity, users)
    state.searching[idCommunity] = false
  },
  setUsers: (state, users) => {
    state.users = users
    state.searching['all'] = false
  },
  searching: (state, key) => {
    state.searching[key] = true
  }
}

const actions = {
  searchUsersByEmails({ commit, state }, emails) {
    return axios.post(`${config.getRootApi()}/users/search`, { emails: emails })
      .then(response => response.data)
  },
  searchUsersByCommunity({ commit, state }, idCommunity) {
    if (idCommunity && !state.searching[idCommunity] && !state.userByCommunity[idCommunity]) {
      commit('searching', idCommunity)
      axios.post(`${config.getRootApi()}/users/search`, { canViewCommunityId: idCommunity })
        .then(response => commit('setUsersFromCommunity', { idCommunity, users: response.data }))
    }
  },
  searchUsersByPublicCommunity({ commit, state }, idCommunity) {
    if (state.searching['all']) {
      return
    }
    if (!state.users) {
      commit('searching', 'all')
      axios.post(`${config.getRootApi()}/users/search`)
        .then(response => {
          commit('setUsers', response.data)
          commit('setUsersFromCommunity', { idCommunity, users: response.data })
        })
    } else {
      commit('setUsersFromCommunity', { idCommunity, users: state.users })
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
